@switch (treatmentType) {
  @case (ConsultationTreatmentTypes.Ed) {
    <app-metformin-ed />
  }
  @case (ConsultationTreatmentTypes.Trt) {
    <app-metformin-trt />
  }
  @case (ConsultationTreatmentTypes.TrtRenewal) {
    <app-metformin-trt />
  }
  @case (ConsultationTreatmentTypes.Peptide) {
    <app-metformin-peptide />
  }
  @case (ConsultationTreatmentTypes.PeptideRenewal) {
    <app-metformin-peptide />
  }
  @case (ConsultationTreatmentTypes.HairLoss) {
    <app-metformin-hair-loss />
  }
  @case (ConsultationTreatmentTypes.Acne) {
    <app-metformin-acne />
  }
  @default {
    <app-metformin />
  }
}
